import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { OeeService } from '@app/services/oee.service';

@Component({
    selector: 'tt-select-oee-state',
    templateUrl: './select-oee-state.component.html',
    styleUrls: ['./select-oee-state.component.css'],
    standalone: false
})
export class SelectOeeStateComponent implements OnInit {
    public items: Item[] = [];

    public arrowSide = '';

    public selecting = false;

    public error = '';

    public canSelect = () => !this.selecting;

    constructor(
        private oee: OeeService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        this.arrowSide = String(this.navigator?.params['arrowside'] ?? '');

        try { this.items = await this.oee.getStates(); }
        catch (error) { this.showError(error); }
    }

    public async select(item: Item): Promise<void> {
        if (this.selecting || item.item_id === '') return;

        this.selecting = true;
        this.error = '';

        try {
            await this.oee.selectState(item.item_id);

            if (this.arrowSide === 'L') {
                await this.navigator?.back();
            } else if (this.arrowSide === 'R' && item['item_path'] !== '' && item.item_state) {
                await this.navigator?.go({
                    to: item.item_state,
                    parms: item.item_parms
                });
            }
        } catch (error) {
            this.showError(error);
        } finally {
            this.selecting = false;
        }
    }

    private showError(error: unknown): void {
        this.error = error instanceof Error ? error.message : String(error);
    }
}
